import styled, { css } from 'styled-components';

import { colors } from '@10d/tend-ui-tokens/samolet';
import { Size } from './types';

export const Wrapper = styled.div<{ size?: Size; attention?: boolean }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${colors.blue600};
  cursor: pointer;

  svg {
    font-size: 32px;
  }

  ${({ size }) =>
    size === Size.Small &&
    css`
      svg {
        font-size: 24px;
      }
    `}

  ${({ attention }) =>
    attention &&
    css`
      svg path {
        fill: ${colors.red600};
      }
    `}
`;

export const Extension = styled.span<{ size?: Size }>`
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;

  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-top: 12px;
  color: ${colors.gray0};
  font-size: 8px;
  font-weight: bold;
  font-family: var(--main-font);
  text-transform: uppercase;
  transform: scale(0.9, 1.05);

  ${({ size }) =>
    size === Size.Small &&
    css`
      padding-top: 12px;
      font-size: 6px;
    `}
`;
